import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import resources from './translations';

// A quick guide on how to write i18next code to keep it consistent

// in namespaces array load every namespace used, if there is only one then make it a string instead
// for the main (first in array) namespace use: t(key)
// for other namespaces use: t(ns:key)
// use keyPrefixes where appropriate but use separate useTranslate hook and rename t: prefixT
// use i18n.t(ns:key) syntax when outside of react component

const languageDetectorOptions = {
  order: [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag',
    'path',
    'subdomain',
  ],
  lookupQuerystring: 'lang',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,
  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode'],
  cookieMinutes: 10,
  cookieDomain: 'myDomain',
  htmlTag: document.documentElement,
  cookieOptions: { path: '/' },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    detection: languageDetectorOptions,
    returnObjects: true,
    keySeparator: '.',
    whitelist: ['en'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
